'use client'

import { useMemo } from 'react'

import { experimentsTrackEvent } from '../eventTracking'
import {
  EXPERIMENTS_TRACK_EVENT_LOGIN_EMAIL_FAILURE,
  EXPERIMENTS_TRACK_EVENT_LOGIN_EMAIL_SUBMIT,
} from '../eventTracking/EXPERIMENTS_TRACK_EVENT'
import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_LOGIN_TWO_STEP } from '../model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../model/EXPERIMENT_VARIATION'
import { type ExperimentType } from '../model/Experiment.types'

import {
  type LoginEmailTracking,
  type LoginEmailTrackingAction,
} from './loginEmailTracking'

const eventByAction: Record<LoginEmailTrackingAction, string> = {
  failure: EXPERIMENTS_TRACK_EVENT_LOGIN_EMAIL_FAILURE,
  submit: EXPERIMENTS_TRACK_EVENT_LOGIN_EMAIL_SUBMIT,
}

const resolveTwoStepLoginEmailTracking = (
  experiment: Pick<ExperimentType, 'isEnabled' | 'variant'>,
): LoginEmailTracking => ({
  track: (action): void => {
    if (
      !experiment.isEnabled ||
      experiment.variant !== EXPERIMENT_VARIATION.V1
    ) {
      return
    }

    experimentsTrackEvent(eventByAction[action])
  },
})

export const useTwoStepLoginEmailTracking = (): LoginEmailTracking => {
  const { isEnabled, variant } = useGetExperiment(
    EXPERIMENT_NAME_LOGIN_TWO_STEP,
  )

  return useMemo(
    () => resolveTwoStepLoginEmailTracking({ isEnabled, variant }),
    [isEnabled, variant],
  )
}
